module.exports = __webpack_public_path__ + "static/img/logoNew.257069b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logoNew.png
// module id = Ij9A
// module chunks = 184